
class Persionlizer {
  constructor(id, personalizeCanvas) {
    this.originInfo = [];

    this.fontInfo = [];
    this.options = {};
    this.customAttribute = [];
    this.variantSettings = [];
    this.bgObj = {};
    this.coolDream = window.coolDream;
    this.personalizeCanvas = personalizeCanvas;
    this.inputInfo = [];
    this.loadPersonal(id);
  }
  loadPersonal (id) {

    const { host, domain } = this.coolDream;

    const originUrl = host + `/api/personalize/product/setting/${id}`;
    const init = {
      method: 'get',
      headers: {
        'user-shop': domain,
        'Content-Type': 'application/json'
      }
    };

    fetch(originUrl, init)
      .then((response) => response.json())
      .then((text) => {
        const result = text;
        if (result.code) {
          this.variantSettings = result.attributes;
          const { fontInfo, options, inputInfo, attributes: customAttribute } = result.data;
          // .sort((prov, next) => prov.input_type < next.input_type ? 1 : -1);
          this.originInfo = inputInfo;
          this.inputInfo = inputInfo;

          this.fontInfo = fontInfo;
          this.options = options;
          this.customAttribute = customAttribute;
          this.getBgImage();
          this.personalizeCanvas.dispatchEvent(new CustomEvent('PersonalizeDataRender', {
            detail: {
              inputInfo: this.originInfo,
              options: this.options,
              fontInfo: this.fontInfo,
              currentVariantSettings: this.currentVariantSettings,
              currentVariantSetting: this.currentVariantSetting
            }
          }));
          this.initPreview();
        }
      })
      .catch(err => { console.log(err); }).finally(() => {
      });
  }
  getVariantSettings () {
    const currentVariant = this.personalizeCanvas.variantSelect.currentVariant;
    if (!currentVariant.id) {
      return false;
    }
    console.log('this.variantSettings:', this.variantSettings, currentVariant.id);
    const currentVariantSettings = this.variantSettings.filter(item => {
      return item.product_variants_id.includes(`gid://shopify/ProductVariant/${currentVariant.id}`);
    });
    this.currentVariantSetting = imageSort(currentVariantSettings);
    return this.currentVariantSetting;
  }
  getVariantSetting (target, groupId, variantSettings) {
    // const variantSettings = this.getVariantSettings(currentVariant);
    const currentVariantSettings = variantSettings.find(item => item.id === groupId);
    if (!currentVariantSettings) {
      return false;
    }
    this.custom_bg_img = this.bgObj[currentVariantSettings.id];
    // this.canvas.groupId = groupId;
    // this.canvas.renderCanvas(this.custom_bg_img, inputInfo);

    // const canvasStep = target.closest('personalize-group-step');
    // canvasStep.renderCanvas();
    // if (target.type == 'file') {
    //   !target.classList.contains('hidden') && target.classList.add('hidden');
    //   canvasStep.renderController(target);
    // }
  }
  getBgImage () {
    const { host, domain } = this.coolDream;
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const width = isMobile ? 400 : 700;
    this.variantSettings.forEach(item => {
      const img = new Image();
      img.src = `${host}/personalize/product/${item.custom_bg_name}?width=${width}&height=${width}`;
      img.setAttribute("crossOrigin", 'Anonymous');

      this.bgObj[item.id] = img;
    });
  }

  initPreview () {
    let listHtml = '';
    const items = this.getVariantSettings();
    items.forEach(v => {
      listHtml += `<canvas width="400" height="400" id="preview_${v.id}"></canvas>`;
    });
    const html = `
        <div class="personalize-photo-dialog">
          <h1>
            <span>Preview</span>
             <div class="personalize-preview-close">
              <button type="button" class="clear btn" title="clear">
                <b class="hidden">clear</b>
              </button>  
            </div>
          </h1>
          <div class="personalize-preview-wrapper">
            <div class="personalize-canvas-prev swiper-button-prev"> </div> 
            <div class="personalize-preview-box">
            </div>
            <div class="personalize-canvas-next swiper-button-next"> </div> 
          </div>
          <div class="controller-btnGroups"><span></span></div>
        </div> 
    `;
    const doc = document.createElement('div');
    doc.className = 'personalize-photo-mask';
    doc.innerHTML = html;
    doc.style.display = 'none';
    document.body.appendChild(doc);
    this.previewBox = doc;
    setTimeout(() => {
      doc.querySelector('.personalize-photo-dialog button.clear')?.addEventListener('click', (e) => {
        doc.style.display = 'none'
      })
      doc.querySelector('.personalize-preview-wrapper .personalize-canvas-prev')?.addEventListener('click', (e) => {
        const box = doc.querySelector('.personalize-preview-box');
        if(box) {
          const width = box.clientWidth || 0;
          const length = box.children.length || 1;
          let scrollLeft = box.scrollLeft || 0;
          if(scrollLeft - width >= 0) {
            scrollLeft = scrollLeft - width
          }
          else {
            scrollLeft = (length-1)*width;
          }
          box.scrollLeft = scrollLeft;
        }
      });
      doc.querySelector('.personalize-preview-wrapper .personalize-canvas-next')?.addEventListener('click', (e) => {
        const box = doc.querySelector('.personalize-preview-box');
        if(box) {
          const width = box.clientWidth || 0;
          const length = box.children.length || 1;
          let scrollLeft = box.scrollLeft || 0;
          if(scrollLeft + width <= (length-1)*width) {
            scrollLeft = scrollLeft + width
          }
          else {
            scrollLeft = 0;
          }
          box.scrollLeft = scrollLeft;
        }
      });
    })
  }
}
class PersonalizeForm {
  constructor(inputInfo, options, fontInfo, customAttribute, showType, personalizeCanvas) {
    // super();
    this.inputInfo = inputInfo;
    this.options = options;
    this.fontInfo = fontInfo;
    this.customAttribute = customAttribute;
    // if (fontInfo) {
    //   this.fontInfo = fontInfo;
    //   this.createFontLink()
    // }
    this.showType = showType;
    this.personalizeCanvas = personalizeCanvas;
    this.sectionId = personalizeCanvas.sectionId;
    this.formId = personalizeCanvas.dataset.formId;
    console.log('formId', this.formId);
    // if (options?.id) {
    //   this.options = options;
    //   this.createOptions(options)
    // }

    this.formElement = this.createInputElement();

  }
  createInputElement () {
    const frag = document.createDocumentFragment();
    console.log('this.inputInfo:', this.inputInfo);
    this.inputInfo.forEach((item, key) => {
      const parser = new DOMParser();
      const inputHtml = parser.parseFromString(this.createGroupElement(item, key), "text/html");
      console.log('key: ', key, inputHtml.querySelector('.personalizeBox_group'));
      frag.appendChild(inputHtml.querySelector('.personalizeBox_group'));

    });
    const content = document.createElement('section');
    content.classList.add('personalize-content');
    const gem = frag.querySelectorAll('.personalizeBox-gem');
    if (gem.length >= 2) {
      content.classList.add('personalizeBox-gems-more');
    }
    content.appendChild(frag);
    console.log('this.showType:', this.showType);
    if (!this.showType) {
      const previewButton = document.createElement('button');
      previewButton.innerText = 'Preview';
      previewButton.classList.add('preview-btn');
      previewButton.classList.add('button');
      previewButton.classList.add('button--full-width');
      content.appendChild(previewButton);
    }

    const group = content.querySelectorAll('.personalizeBox_group');
    group[0].classList.add('active');
    return content;
  }
  createGroupElement (info, key) {
    console.log('info:', info)
    const mergeFront = info.attribute.merge_front_options ? true : false;
    const lastIndex = info.info.findLastIndex(v => v.input_type === 0 && v.font_group_id > 0);
    let defaultFont;
    // const nonDefaultFront = info.info.filter(item => item.input_type === 0).every(item => item.font_group_id > 0);
    const result = info.info.map((item, index) => {
      item.id = item.id ? item.id : new Date().getTime() + Math.random()
        .toString(36)
        .substring(2, 10);
      // 是否合并字体选项
      const withFontOption = mergeFront ? (index == lastIndex ? true : false) : true;
      if (withFontOption  && item.input_type === 0 && this.fontInfo) {
        item.font_group_id = info.info.find(item => item.input_type === 0 && item.font_group_id)?.font_group_id;    
        const defaultFontId = this.fontInfo.font_group.find(v => v.id === item.font_group_id)?.font_ids[0];
        defaultFont = this.fontInfo.fontList.find(item => item.id === defaultFontId);
      }
      return this.createElement(index, item, withFontOption);
    }).join('\n');
    return this.showType == 0 ? `
      <section data-attribute-id="${key}" data-merge-front="${info.attribute.merge_front_options}"  class="personalizeBox_group" open ${mergeFront ? 'style="--personalize-fontFamily:' + defaultFont?.name + '"' : ''}>
        ${result}
      </section>
    ` : `
      <personalize-group-step data-attribute-id="${key}" data-merge-front="${info.attribute.merge_front_options}"  class="personalizeBox_group" open ${mergeFront ? 'style="--personalize-fontFamily:' + defaultFont?.name + '"' : ''}>
        ${result}
      </personalize-group-step>
    `;
  }
  createElement (index, elem, withFontOption = true) {
    const { group_name, required, word_count, font_group_id, id, color, input_type } = elem;
    let fontSlt;
    let firstFont;
    if (input_type === 0 && font_group_id > 0 && withFontOption && this.fontInfo) {
      const font_group = this.fontInfo.font_group.find(item => item.id === font_group_id);

      fontSlt = this.createFontElement(font_group, group_name);
      firstFont = this.fontInfo.fontList.find(item => item.id === font_group.font_ids[0]);
    }
    const { inputHtml, dialogHtml } = this.switchHTML(index, elem);
    if (dialogHtml) {
      const dialogDom = document.createElement('div');
      dialogDom.classList.add('controller-box');
      dialogDom.classList.add('personalize-photo-mask');
      dialogDom.innerHTML = dialogHtml;
      document.body.appendChild(dialogDom);
    }
    return `
      <section  class="personalizeBox ${input_type == 2 ? 'personalizeBox-gem' : ''}" ${input_type === 0 && font_group_id > 0 && withFontOption ? "style=--personalize-fontFamily:" + firstFont.name : ''}>
      <legend class="form__label">${required ? '<span class="required">*</span>' : ''} ${group_name} <span class="attribute-mark" > </span> <span class="word_count">${word_count ? word_count + 'characters' : ''} </span></legend>
      <fieldset class="js product-form__input">
        ${inputHtml}
        ${required ? '<span class="error">This input is required!</span>' : ''}
      </fieldset>
      ${input_type === 0 && font_group_id > 0 && withFontOption ? fontSlt : ''}
      </section>
    `;
  }
  createFontLink () {
    const { fontList } = this.fontInfo;
    const { host } = window.coolDream;

    let fontStr = '', linkElement = '';
    fontList.forEach(item => {
      fontStr += `
          @font-face {
              font-family: ${item.name};
              src: url(${host}/personalize/font/${item.file_url}) format('woff2');
              /* 添加其他字体属性 */
          }
          .${item.name} {
            font-family: ${item.name};
          }
      `;
      linkElement += `<link rel="preload" href="${host}/personalize/font/${item.file_url}" as="font" type="font/woff2" crossorigin>`;
    });
    const fontStyle = `
      <section>
      ${linkElement}
        <style>
        ${fontStr}
      </style>
      </section>


    `;

    const parser = new DOMParser();
    const fontStyleHtml = parser.parseFromString(fontStyle, "text/html");
    // this.appendChild(fontStyleHtml.querySelector('section'));
    return fontStyleHtml;
  }
  createFontElement (fontInfo, input_name) {
    const { group_name, font_ids } = fontInfo;
    // const fontList = this.fontInfo.fontList.filter(item => font_ids.includes(item.id));
    const fontList = font_ids.map(item => this.fontInfo.fontList.find(cItem => cItem.id === item));
    let options = '';
    fontList.forEach(item => {
      options += `<option class="${item.name}" value="${item.file_url}">${item.name}</option>`;
    });
    return `
      <section class="personalizeBox" ${font_ids.length === 1 ? 'style="height:0;visibility:hidden;"' : ""}>
      <legend class="form__label"> ${group_name} </legend>
      <fieldset class="js product-form__input">
        <select   id="template--${this.sectionId}__main-${group_name.replace(' ', '_')}-${input_name.replace(' ', '_')}-select" name="properties[${input_name}_font]" class="personalize_input swatch-input" value=""  form="${this.formId}">
            ${options}
        </select>
      </fieldset>
      </section>
    `;
  }
  createOptions (elem) {
    const { group_name, options } = elem;

    let optionsHtml = '';

    options.forEach((item, index) => {
      // <input type="radio" id="template-${this.sectionId}__main-${index}-${group_name}_option" name="properties[${group_name}]" class="swatch-radio" value="${item}" form="${this.formId}" ${index === 0 ? "checked" : ""} />
      // <label for="template-${this.sectionId}__main-${index}-${group_name}_option" data-swatch="${item}" title="${item}" class="visibility"><span class="variant_title">${item}</span></label>
      optionsHtml += `
        <option  value="${item}">${item}</option>
      `;
    });

    const optionsBoxStr = `
    <section class="personalizeBox tags-picker">
      <legend class="form__label">${group_name}</legend>
      <fieldset class="js product-form__input">
      <select   id="template--${this.sectionId}__main-${group_name.replace(' ', '_')}-option-select" name="properties[${group_name}]" class="personalize_input swatch-input" value=""  form="${this.formId}">
          ${optionsHtml}
      </select>
      </fieldset>
    </section>
    `;
    const parser = new DOMParser();
    const optionsBoxHTML = parser.parseFromString(optionsBoxStr, "text/html");
    return optionsBoxHTML;
    // const canvasElem = this.querySelectorAll('personalize-canvas-step')
    // canvasElem[canvasElem.length - 1].appendChild(optionsBoxHTML.querySelector('.personalizeBox'));
  }
  createAttributes (elem, group_name_str) {
    const { group_name, options } = elem;

    let optionsHtml = '';

    options.forEach((item, index) => {
      optionsHtml += `
        <option  value="${item}">${item}</option>
      `;
    });

    const optionsBoxStr = `
    <select   id="template--${this.sectionId}__main-${group_name_str}-option-select" name="properties[${group_name_str}]" class="personalize_input swatch-input" value=""  form="${this.formId}">
          ${optionsHtml}
      </select>
    `;
    return optionsBoxStr;
  }
  switchHTML (index, data) {
    const { group_name, required, word_count, input_type, options_ids, font_group_id, id, color, text_type } = data;
    const group_name_str = group_name.replace(' ', '-');
    let inputHtml;
    let dialogHtml;
    switch (input_type) {
      case 0:
        inputHtml = text_type === 1 ?
          `<input style="--input-color: ${color}" ${required ? 'required' : ''} type="text"   maxlength="${word_count}"  id="template--${this.sectionId}__main-${index}-${group_name_str}-input" name="properties[${group_name_str}]" class="personalize_input swatch-input" value="" form="${this.formId}"  data-input-info-id="${id}" />` :
          `<textarea style="--input-color: ${color}" ${required ? 'required' : ''}    maxlength="${word_count}" rows=${3}  id="template--${this.sectionId}__main-${index}-${group_name_str}-input" name="properties[${group_name_str}]" class="personalize_input swatch-input" value="" form="${this.formId}"  data-input-info-id="${id}"></textarea>`;
        break;
      case 1:
        if (this.showType == 0) {
          inputHtml = `
          <div class="personalize-photo-box">
            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="upload-icon-vjzGD tw-icon-static tw-h-8 tw-w-8 tw-text-gray-4 tw-mb-1 customeow-icon customeow-icon-icon-image-photo-plus-solid" width="20" height="20"><path d="M1 5.25C1 4.65326 1.23705 4.08097 1.65901 3.65901C2.08097 3.23705 2.65326 3 3.25 3H16.75C17.0455 3 17.3381 3.0582 17.611 3.17127C17.884 3.28434 18.1321 3.45008 18.341 3.65901C18.5499 3.86794 18.7157 4.11598 18.8287 4.38896C18.9418 4.66194 19 4.95453 19 5.25V9.5H13.5C11.9944 9.5 10.6831 10.3318 10.0006 11.5609L6.53 8.091C6.38937 7.95055 6.19875 7.87166 6 7.87166C5.80125 7.87166 5.61063 7.95055 5.47 8.091L2.5 11.06V14.75C2.5 15.164 2.836 15.5 3.25 15.5H9.5V17H3.25C2.65326 17 2.08097 16.7629 1.65901 16.341C1.23705 15.919 1 15.3467 1 14.75V5.25ZM12 7C12 7.26522 11.8946 7.51957 11.7071 7.70711C11.5196 7.89464 11.2652 8 11 8C10.7348 8 10.4804 7.89464 10.2929 7.70711C10.1054 7.51957 10 7.26522 10 7C10 6.73478 10.1054 6.48043 10.2929 6.29289C10.4804 6.10536 10.7348 6 11 6C11.2652 6 11.5196 6.10536 11.7071 6.29289C11.8946 6.48043 12 6.73478 12 7Z" fill="#d1d5db" fill-rule="evenodd" clip-rule="evenodd"></path><path d="M16.25 12C16.25 11.5858 15.9142 11.25 15.5 11.25C15.0858 11.25 14.75 11.5858 14.75 12V14.25H12.5C12.0858 14.25 11.75 14.5858 11.75 15C11.75 15.4142 12.0858 15.75 12.5 15.75H14.75V18C14.75 18.4142 15.0858 18.75 15.5 18.75C15.9142 18.75 16.25 18.4142 16.25 18V15.75H18.5C18.9142 15.75 19.25 15.4142 19.25 15C19.25 14.5858 18.9142 14.25 18.5 14.25H16.25V12Z" fill="#e60044" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
            <div>Photo</div>
            <div>(1/1)</div>
            <input  ${required ? 'required' : ''} type="file"  id="template--${this.sectionId}__main-${index}-${group_name_str}-input" name="properties[${group_name_str}]" class="personalize-photo-input personalize_input swatch-input" value="" form="${this.formId}"  data-input-info-id="${id}" />
            <div class="personalize-photo-selected"  data-input-info-id="${id}">         
              <img src="" class="personalize-photo-selected-img" data-input-info-id="${id}"/>
              <span class="clear-btn" data-input-info-id="${id}"></span>
            </div>
          </div>`;
          dialogHtml = `<div class="personalize-photo-dialog">
            <h1>Photo crop</h1>
            <canvas id="template--${this.sectionId}__main-${index}-${group_name_str}-canvas" data-input-info-id="${id}"
            class="personalize_contorller" width="375" height="375"></canvas>
            <p class="controller-btnGroups">
              <button type="button" class="clear btn" title="clear">
                <b class="hidden">clear</b>
              </button>
              <button type="button" class="scaleLarge scale btn" title="scale large">
                <b class="hidden">scale large</b>
              </button>
              <button type="button" class="scaleSmall scale btn" title="scale small">
                <b class="hidden">scale small</b>
              </button>
              <button type="button" class="angleLeft angle btn" title="angle left">
                <b class="hidden">angle left</b>
              </button>
              <button type="button" class="angleRight angle btn" title="angle right">
                <b class="hidden">angle right</b>
              </button>    
              <button type="button" class="confirm btn" title="confirm">
                <b class="hidden">confirm</b>
              </button>
            </p>
          </div>`;
        } else {
          inputHtml = `<input  ${required ? 'required' : ''} type="file"  id="template--${this.sectionId}__main-${index}-${group_name_str}-input" name="properties[${group_name_str}]" class="personalize_input swatch-input" value="" form="${this.formId}"  data-input-info-id="${id}" />

        <article class="controller-box">
          <p class="controller-btnGroups">
            <button type="button" class="scaleLarge scale btn" title="scale large">
              <b class="hidden">scale large</b>
            </button>
            <button type="button" class="scaleSmall scale btn" title="scale small">
              <b class="hidden">scale small</b>
            </button>
            <button type="button" class="angleLeft angle btn" title="angle left">
              <b class="hidden">angle left</b>
            </button>
            <button type="button" class="angleRight angle btn" title="angle right">
              <b class="hidden">angle right</b>
            </button>
            <button type="button" class="clear btn" title="clear">
              <b class="hidden">clear</b>
            </button>
          </p>
          <canvas id="template--${this.sectionId}__main-${index}-${group_name_str}-canvas" data-input-info-id="${id}"
          class="personalize_contorller" width="280" height="280"></canvas>
        </article>
        `;
        }

        break;
      case 2:
        const gemOptions = this.customAttribute.find(item => item.id === options_ids);
        const gemOptionsClass = gemOptions.group_name.replaceAll(' ', '-');
        const birthstone = document.getElementById('gem-personalize-product').content.querySelector(`.${gemOptionsClass}`);
        console.log('gemOptions:', gemOptionsClass)
        console.log('gemOptionsClass:', gemOptionsClass)
        birthstone.querySelectorAll('input').forEach(item => {
          const Id = item.getAttribute('id');
          item.setAttribute('id', `${Id}-${group_name_str}`);
          item.setAttribute('data-input-info-id', id);
          item.setAttribute('name', `properties[${group_name_str}]`);
          if (required) {
            item.setAttribute('required', true);
          }
        });
        birthstone.querySelectorAll('label').forEach(item => {
          const Id = item.getAttribute('for');
          item.setAttribute('for', `${Id}-${group_name_str}`);
        });
        inputHtml = birthstone.outerHTML;
        break;
      case 3:
        const options = this.customAttribute.find(item => item.id === options_ids);
        inputHtml = this.createAttributes(options, group_name_str);
        break;

    }
    return { inputHtml, dialogHtml };
  }
}

class PersonalizeContorller {
  constructor(inputInfo, personalizeCanvas) {
    this.personalizeCanvas = personalizeCanvas;
    this.controllerElement = new Map();
    this.contorllerInputInfo = '';
    this.personalizeForm = '';
    this.groupId = '';
    this.inputInfo = inputInfo;
    this.controllers = new Map();
    this.initScale = 1;
    this.minScale = 1;
    this.maxScale = 1;

  }
  /**
     * 有图片上传时，才初始化的控制器
     */
  initController (element) { 
    if (!element.dataset.inputInfoId) return;
    const inputElement = this.personalizeCanvas.querySelector('input[type=file][data-input-info-id="' + element.dataset.inputInfoId + '"]');
    // const inputElement = element.closest('.product-form__input').querySelector('input[type=file]');
    console.log('dddd:', inputElement, this.controllerElement.has(inputElement))
    if (!this.controllerElement.has(inputElement)) {
      this.controllerElement.set(inputElement, element);
    }
    if (fabric && !this.controllers.has(inputElement)) {
      this.controllers.set(inputElement, new fabric.Canvas(element, {
        controlsAboveOverlay: true,
        selection: false,
        crossOrigin: 'anonymous'
      }));
    }

  }
  renderController (target, inputInfo) {
    const fileInput = target;
    const inputInfoId = fileInput.dataset.inputInfoId;
    this.findControllerInputInfo(inputInfoId);
    // this.inputInfo
    const currentInfo = this.contorllerInputInfo;
    const { width_percent, height_percent, x_position_percent, y_position_percent, font_size, value = '', fontFamily, color, input_type, shape } = currentInfo;

    const contorller = this.controllers.get(target);

    // const canvas = this.canvas;
    const width = contorller.width - 4;
    const height = contorller.height - 4;
    const scaleRatio = Math.min(1 / width_percent, 1 / height_percent);
    let boxWidth = width * width_percent * scaleRatio,
      boxHeight = height * height_percent * scaleRatio;

    console.log('widthScale', boxWidth, boxHeight, width_percent, height_percent);
    // 检查是否选择了文件
    if (fileInput.files.length > 0) {

      contorller.clear();
      const selectedFile = fileInput.files[0];
      let clippath;
      if (shape === 2) {
        clippath = new fabric.Circle({
          radius: Math.max(boxWidth, boxHeight) / 2 - 2,
          fill: 'transparent',
          originX: 'center', originY: 'center',
          absolutePositioned: true,
          hasControls: false,
          selectable: false,
          top: boxWidth / 2 + 5,
          left: boxHeight / 2 + 5,
        });
        contorller.add(new fabric.Circle({
          radius: Math.max(boxWidth, boxHeight) / 2,
          fill: 'transparent',
          absolutePositioned: true,
          originX: 'center', originY: 'center',
          hasControls: false,
          selectable: false,
          top: boxWidth / 2 + 5,
          left: boxHeight / 2 + 5,
          strokeWidth: 4,  // 设置边框宽度
          stroke: '#ae0a09',   // 设置边框颜色
        }));
      } else {
        clippath = new fabric.Rect({
          left: contorller.width / 2,
          top: contorller.height / 2,
          originX: 'center', originY: 'center',
          width: boxWidth - 4,
          height: boxHeight - 4,
          absolutePositioned: true,
          id: 'chilpath'
        });
        contorller.add(new fabric.Rect({
          left: contorller.width / 2,
          top: contorller.height / 2,
          originX: 'center', originY: 'center',
          width: boxWidth,
          height: boxHeight,
          fill: 'transparent',
          absolutePositioned: true,
          // padding: 10,
          hasControls: false,
          selectable: false,
          strokeWidth: 4,  // 设置边框宽度
          stroke: '#ae0a09',   // 设置边框颜色
        }));
      }
      // 使用 Fabric.js 的 fabric.Image.fromURL 加载图片到画布
      fabric.Image.fromURL(URL.createObjectURL(selectedFile), function (img) {
        // 设置图片的位置、大小等属性
        img.scaleToWidth(boxWidth * 1);
        img.scaleToHeight(boxHeight * 1);
        img.clipPath = clippath;
        contorller._selfClippath = clippath;
        img.set({
          left: contorller.width / 2,
          top: contorller.height / 2,
          originX: 'center', originY: 'center',
          crossOrigin: 'anonymous',
          transparentCorners: false,
        });
        img.setControlsVisibility({
          ml: false,
          mr: false,
          mt: false,
          mb: false
        });
        this.initScale = Math.max(img.scaleX, img.scaleY);
        this.minScale = calculateRepeatedSubtraction(Math.max(img.scaleX, img.scaleY));
        this.maxScale = calculateRepeatedSubtraction(Math.max(img.scaleX, img.scaleY), true);
        contorller.add(img);
        contorller.setActiveObject(img);
        contorller.renderAll();
        this.contorllerClipPath(target);

        // const obj = contorller.getObjects().find(item => item instanceof fabric.Image);
        // contorller.setActiveObject(obj);

      }.bind(this), {crossOrigin: 'anonymous'});
      this.showContorller(target);
    }
  }

  contorllerClipPath (target, isClear=false) {
    // const controllerElement = this.controllerElement.get(target);
    const inputInfoId = target.dataset.inputInfoId;
    // const personalizeCanvasElem = this.personalizeCanvas;

    this.findControllerInputInfo(inputInfoId);



    // const canvas = this.canvas;
    const contorller = this.controllers.get(target);
    // canvas.getObjects().forEach((obj) => {
    //   console.log(obj.id)
    //   if (obj instanceof fabric.Image && obj.id === `contorllerClipPath${inputInfoId}`) {
    //     canvas.remove(obj);
    //   }
    // });
    const clippath = contorller._selfClippath;
    const clippathWidth = clippath.width;
    const left = (contorller.width - clippathWidth) / 2;
    const top = (contorller.height - clippath.height) / 2;
    if(!isClear) {
      const croppedImageData = contorller.toDataURL({
        format: 'png',  // 选择输出格式，可以是 'png'、'jpeg' 等
        left: left,  // 设置导出区域的左上角坐标
        top: top,
        width: clippathWidth,  // 设置导出区域的宽度和高度
        height: clippath.height,
        multiplier: 2  // 设置导出图像的分辨率倍数
      });
      this.contorllerInputInfo.value = croppedImageData;
    }
    else {
      this.contorllerInputInfo.value = '';
    }
    this.personalizeCanvas.renderCanvas(target);
    // this.renderCanvas(this.custom_bg_img, this.inputInfo);

  }
  findControllerInputInfo (inputInfoId) {
    this.contorllerInputInfo = this.inputInfo.find(info => info.id == inputInfoId);
  }
  bindControllerEvent (inputTarget) {
    const contorller = this.controllers.get(inputTarget);
    const contorllerElement = this.controllerElement.get(inputTarget);
    const contorllerElementGroupBox = contorllerElement.closest('.controller-box').querySelector('.controller-btnGroups');
    const btn = contorllerElementGroupBox.querySelectorAll('button');

    // 初始化 Hammer.js
    const hammerManager = new Hammer.Manager(contorller.upperCanvasEl);
    const pinch = new Hammer.Pinch();
    const rotate = new Hammer.Rotate();
    const pan = new Hammer.Pan({ direction: Hammer.DIRECTION_ALL });
    // pinch.recognizeWith(pan);
    let scale = false;
    // 添加到 Hammer.js 管理器
    hammerManager.add([pinch, pan]);
    hammerManager.on('pan', (e) => {
      console.log('拖动事件', e);
    });
    hammerManager.on('tap', (e) => {
      console.log('tap', e);
    });
    hammerManager.on('pinchmove', (e) => {
      scale = true;
    });
    hammerManager.on('pinchend', (e) => {
      scale = false;
    });
    hammerManager.on('pinchcancel', (e) => {
      scale = false;
    });
    const debouncePinchin = debounce((e) => {
      console.log('pinchin', e);
      if (scale) {
        this.scale(false, contorller);
      }
    }, 16);
    hammerManager.on('pinchin', debouncePinchin);
    const debouncePinchout = debounce((e) => {
      console.log('pinchout', e);
      if (scale) {
        this.scale(true, contorller);
      }
    }, 16);
    hammerManager.on('pinchout', debouncePinchout);
    btn.forEach(function (item) {
      item.addEventListener('click', function (e) {
        const target = e.target;
        if (target.classList.contains('scale')) {
          const scaleResult = target.classList.contains('scaleLarge');
          // scale 为true，并scaleResult为大
          // scale 为false，并scaleResult为小。

          this.scale(scaleResult, contorller);
        }
        else if (target.classList.contains('angle')) {
          this.rotate(target.classList.contains('angleLeft'), contorller);
        }
        else if (target.classList.contains('clear')) {
          const fileElement = this.personalizeCanvas.querySelector('input[type=file][data-input-info-id="' + this.contorllerInputInfo.id + '"]');
          // const fileElement = target.closest('.product-form__input').querySelector('input[type="file"]')
          fileElement.value = '';
          fileElement.classList.remove('hidden');
          contorller.clear();
          if (this.controllerElement.has(fileElement)) {
            const currentControllerElement = this.controllerElement.get(fileElement);
            const parentElement = currentControllerElement.closest('.controller-box');
            if (parentElement.classList.contains('show')) {
              parentElement.classList.remove('show');
            }
          }
        }
        else if (target.classList.contains('confirm')) {
          const fileElement = this.personalizeCanvas.querySelector('input[type=file][data-input-info-id="' + this.contorllerInputInfo.id + '"]');
          const imgDataURL = this.controllers.get(fileElement).toDataURL();
          const imgElement = this.personalizeCanvas.querySelector('.personalize-photo-selected-img[data-input-info-id="' + this.contorllerInputInfo.id + '"]');
          const imgBox = this.personalizeCanvas.querySelector('.personalize-photo-selected[data-input-info-id="' + this.contorllerInputInfo.id + '"]');
          imgElement.src = imgDataURL;
          imgBox.style.display = 'block';
          if (this.controllerElement.has(fileElement)) {
            const currentControllerElement = this.controllerElement.get(fileElement);
            const parentElement = currentControllerElement.closest('.controller-box');
            if (parentElement.classList.contains('show')) {
              parentElement.classList.remove('show');
            }
          }
        }
        setTimeout(() => {
          this.contorllerClipPath(inputTarget, target.classList.contains('clear'));
        });
        // this.contorllerClipPath(inputTarget);
      }.bind(this));
    }.bind(this));
  }

  scale (small = false, contorller) {

    const obj = contorller.getObjects().find(item => item instanceof fabric.Image);

    if ((small && obj.scaleX >= this.maxScale) || (!small && obj.scaleX <= this.minScale)) {
      return false;
    }

    const step = Math.max(obj.scaleX * (1 / 10), obj.scaleY * (1 / 10));
    const scaleX = obj.scaleX;
    const scaleY = obj.scaleY;
    // obj.set({
    //   scaleX: small ? scaleX - step : scaleX + step,
    //   scaleY: small ? scaleY - step : scaleY + step
    // })
    obj.scaleX = Math.max(small ? scaleX + step : scaleX - step);
    obj.scaleY = Math.max(small ? scaleY + step : scaleY - step);

    console.log('small:', small);

    contorller.setActiveObject(obj);
    contorller.renderAll();
  }
  rotate (left = false, contorller) {
    const obj = contorller.getObjects().find(item => item instanceof fabric.Image);
    const step = 15;
    const currentAngle = obj.angle;
    obj.angle = left ? currentAngle - step : currentAngle + step; // 将对象顺时针旋转 45 度
    contorller.renderAll();
    contorller.setActiveObject(obj);

  }
  showContorller (target) {
    const currentControllerElement = this.controllerElement.get(target);
    const parentElement = currentControllerElement.closest('.controller-box');
    if (!parentElement.classList.contains('show')) {
      // this.personalizeForm = currentControllerElement.closest('personalize-form-')
      parentElement.classList.add('show');
      console.log('controllers:', this.controllers);
      this.controllers.forEach(function (item) {
        item.on('mouse:up', function (options) {
          if (options.target) {
            console.log('options:', options);
            // 移除 canvas 画布上的所有非 Image 对象
            // const inputTarget = options.e.target.closest('.product-form__input').querySelector('input[type="file"]');
            const inputTarget = this.personalizeCanvas.querySelector('input[type=file][data-input-info-id="' + this.contorllerInputInfo.id + '"]');
            console.log('target, options.target', options.target, target);
            this.contorllerClipPath(inputTarget);

          }
        }.bind(this));
      }.bind(this));
      console.log('abc:', target);
      this.bindControllerEvent(target);
    }
  }
  clearAll() {
    
  }
}
if (!window.customElements.get('personalize-canvas')) {
  class PersonalizeCanvas extends HTMLElement {
    constructor() {
      super();

      const productId = this.dataset.productId;
      this.sectionId = this.dataset.sectionId;
      this.productInfo = this.dataset.productInfo;

      const onlyDefaultVariant = parseInt(this.dataset.onlyDefaultVariant);
      this.onlyDefaultVariant = onlyDefaultVariant;
      this.variantSelect = this.closest('product-info');
      this.variantSelect = onlyDefaultVariant ? this.getVariantData() : this.variantSelect;
      this.inputInfo = new Map();

      this.personalize = new Persionlizer(productId, this);
      this.showType = parseInt(this.dataset.showType);
      this.canvas = '';
      this.onVariantChangeUnsubscriber = () => { };
      this.cacheVariant = '';
    }
    connectedCallback () {
      const productId = this.dataset.productId;
      const showType = parseInt(this.dataset.showType);
      if (showType === 0) {
        this.canvas = document.querySelector(`[data-personlizer-id=${this.id}]`);
      }
      this.onVariantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange, () => {
          const currentVariant = this.onlyDefaultVariant ? this.variantSelect.currentVariant : this.variantSelect.getSelectedVariant(this.variantSelect);
          const cacheValue = typeof this.cacheVariant === 'object' ? JSON.stringify(this.cacheVariant) : '';
          const currentValue = typeof currentVariant === 'object' ? JSON.stringify(currentVariant) : '';
          if (cacheValue !== currentValue) {
            console.log('variantChange');
            this.renderSection();
            // this.renderCanvas(this.querySelector('.personalizeBox'));
          }
          if(this.canvas) {
            this.canvas.previewFile.clear();
            this.canvas.hide();
          }
        });

      window.addEventListener('VariantChange', this.init.bind(this));
      this.addEventListener('PersonalizeDataRender', this.init.bind(this));
    }
    disconnectedCallback () {
      this.onVariantChangeUnsubscriber();
    }
    init () {
      this.innerHTML = '';
      this.renderSection();
    }
    getVariantData () {
      const productId = `json-${this.dataset.productId}`;

      return { currentVariant: JSON.parse(document.getElementById(productId).textContent)[0] };
    }
    renderSection () {
      //重置inputinfo；
      console.log('inputEventListener 2223');
      this.restInputInfo();
      const currentVariant = this.onlyDefaultVariant ? this.variantSelect.currentVariant : this.variantSelect.getSelectedVariant(this.variantSelect);
      this.cacheVariant = currentVariant;
      this.variantSelect.currentVariant = currentVariant;
      // this.inputInfo.clear();
      const { fontInfo, options, originInfo, customAttribute } = this.personalize;
      const inputInfo = JSON.parse(JSON.stringify(originInfo));

      console.log('getVariantSettings 2223', currentVariant);
      this.personalizeContorller = new PersonalizeContorller(inputInfo, this);

      const getVariantSettings = this.personalize.getVariantSettings(this.variantSelect.currentVariant);
      console.log('getVariantSettings 2223', getVariantSettings);

      // 控制定制/加购按钮
      const cd_add_to_cart = document.getElementById('cd-add_to_cart-' + this.sectionId);
      const custom_product = document.getElementById('custom_product-' + this.sectionId);
      if(getVariantSettings.length && this.showType) {
        custom_product?.classList.remove('hidden');
        cd_add_to_cart?.classList.add('hidden');
        cd_add_to_cart?.setAttribute('data-personalize', '1');
      } else {
        custom_product?.classList.add('hidden');
        cd_add_to_cart?.classList.remove('hidden');
        cd_add_to_cart?.setAttribute('data-personalize', getVariantSettings.length > 0 ? '1' : '0');
      }

      if (!getVariantSettings.length) {
        this.dispatchEvent(new CustomEvent('PersonalizeFormStepRender', {
          // detail: {
          //   inputInfo: this.inputInfo,
          //   options: this.options,
          //   fontInfo: this.fontInfo,
          //   currentVariantSettings: this.currentVariantSettings,
          //   currentVariantSetting: this.currentVariantSetting
          // }
        }));
        this.innerHTML = '';
        return false;
      };
      this.currentVariantSettings = getVariantSettings;

      // 根据属性设置进行分组。
      getVariantSettings.forEach(item => {
        if (!item.is_alone) {
          // const info = inputInfo.filter(cItem => item.input_settings_ids.includes(cItem.id))
          const info = item.input_settings_ids.map(cItem => inputInfo.find(children => children.id == cItem));
          this.inputInfo.set(item.id, {
            attribute: item,
            info
          });
        } else { 
          this.inputInfo.set(item.id, {
            attribute: item,
            info: item.alone_settings
          });
        }
        if(this.showType === 0) {
          this.canvas.attributeIds = [];
          if(this.canvas.attributeIds.indexOf(item.id) === -1) {
            this.canvas.attributeIds.push(item.id);
          }
        }
      });
      this.innerHTML = '';
      const form = new PersonalizeForm(this.inputInfo, options, fontInfo, customAttribute, this.showType, this);

      if (fontInfo) {
        // this.fontInfo = fontInfo;
        const fontStyleHtml = form.createFontLink();
        this.appendChild(fontStyleHtml.querySelector('section'));
      }
      if (options?.id) {
        // this.options = options;
        const sltOptions = this.createOptions(options);
        const canvasElem = this.querySelectorAll('.personalizeBox_group');
        canvasElem[canvasElem.length - 1].appendChild(sltOptions.querySelector('.personalizeBox'));
      }
      this.appendChild(form.formElement);
      this.dispatchEvent(new Event('personalizeCanvasRender'));
      // const attributeId = parseInt(this.querySelector('.personalizeBox_group').dataset.attributeId);
      // this.canvas = this.querySelector('.personalizeBox_group');
      // this.canvas.renderCanvas(attributeId);
      
      // 绑定监控事件
      if (this.querySelectorAll('select').length) {
        this.changeEventListener(this.querySelectorAll('select'));
      }
      this.inputEventListener();
    }
    getCurrentInfo (groupId) {
      return this.inputInfo.get(groupId)?.info;
    }
    inputEventListener () {
      const radioElem = this.querySelectorAll('input[type="radio"]');
      radioElem.forEach(
        item => {
          item.addEventListener('change', function (e) {
            console.log('radio', e);
            const target = e.target;
            radioChange.call(this, target);
          }.bind(this));
        }
      );

      // this.querySelectorAll('input[type="radio"]:checked').forEach(item => {
      //   radioChange.call(this, item, true);
      // });
      function radioChange (target, notFirst = false) {
        const groupId = parseInt(target.closest('.personalizeBox_group').dataset.attributeId);
        // const personalizeBox = target.closest('.personalizeBox');
        // const currentVariantSetting =;
        const currentAttributeInfo = this.getCurrentInfo(groupId);
        const inputInfo = currentAttributeInfo.find(item => target.dataset.inputInfoId == item.id);
        const img = target.nextElementSibling.children[0].src;
        inputInfo.value = img;
        inputInfo.label = target.value;
        const box = target.closest('.personalizeBox-gem');
        box.querySelector('.form__label .attribute-mark').textContent = `: ${target.value}`;
        this.renderCanvas(target);

        !notFirst && this.personalize.getVariantSetting(target, groupId, this.currentVariantSettings);
      }

      const debounceInput = debounce(function (e) {
        console.log('debounceInput 2223');
        const target = e.target;
        const box = target.closest('.personalizeBox_group');
        const mergeFront = parseInt(box.dataset.mergeFront);
        const groupId = parseInt(box.dataset.attributeId);
        const personalizeBox = target.closest('.personalizeBox');
        // const currentVariantSetting =;
        const currentAttributeInfo = this.getCurrentInfo(groupId);
        const inputInfo = currentAttributeInfo.find(item => target.dataset.inputInfoId == item.id);
        if (target.maxLength > 0) {
          const count = target.maxLength - target.value.length;
          personalizeBox.querySelector('.word_count').textContent = `${count}characters`;
        }
        inputInfo.value = target.value;

        if(inputInfo.font_group_id !== 0) {
          if (!mergeFront) {
            inputInfo.fontFamily = personalizeBox.style.getPropertyValue('--personalize-fontFamily');
          }
          else {
            inputInfo.fontFamily = box.style.getPropertyValue('--personalize-fontFamily');
          }
        }
        this.personalize.getVariantSetting(target, groupId, this.currentVariantSettings);
        if (target.type == 'file') {
          const controllers = Array.from(document.querySelectorAll('.personalize_contorller')).filter(v => v.className.indexOf('lower-canvas') === -1 && v.className.indexOf('lower-canvas') === -1);
          const personalizeContorller = this.personalizeContorller;
          if (controllers.length) {
            controllers.forEach(controller => {
              personalizeContorller.initController(controller);
            });
          }
          !target.classList.contains('hidden') && target.classList.add('hidden');
          personalizeContorller.renderController(target);
        }
        this.renderCanvas(target);

      }.bind(this), 100);
      const inputElem = this.querySelectorAll('input.personalize_input, textarea.personalize_input');
      inputElem.forEach(item => {
        item.addEventListener('input', debounceInput);
      });

      const onClearBtnClick = (e) => {
        const target = e.target;
        const inputInfoId = target.dataset.inputInfoId;
        const fileElement = this.querySelector('input[type=file][data-input-info-id="' + inputInfoId + '"]');
        const contorller = this.personalizeContorller?.controllers.get(fileElement);
        const imgElement = this.querySelector('.personalize-photo-selected-img[data-input-info-id="' + inputInfoId + '"]');
        const imgBox = this.querySelector('.personalize-photo-selected[data-input-info-id="' + inputInfoId + '"]');

        fileElement.value = '';
        fileElement.classList.remove('hidden');
        contorller.clear();
        imgElement.src = '';
        imgBox.style.display = 'none';
        setTimeout(() => {
          if (this.personalizeContorller) {
            this.personalizeContorller.contorllerClipPath(fileElement, true);
          }
        });
      };
      const clearPhotoBtns = this.querySelectorAll('.clear-btn');
      clearPhotoBtns.forEach(btn => {
        btn.addEventListener('click', onClearBtnClick);
      });
      const previewBtn = this.querySelector('.preview-btn');
      previewBtn?.addEventListener('click', async (e) => {
        const fragment = document.createDocumentFragment();    
        for(const item of this.canvas.attributeIds) {
          const canvas = await this.canvas.renderCanvas(item);
          const img = document.createElement('img');
          img.crossOrigin="anonymous";
          console.log('canvas1:', canvas);
          img.src = canvas.toDataURL({ format: 'png', multiplier: 1.5, quality: 1 });
          fragment.appendChild(img); 
        }
        document.querySelector('.personalize-preview-box').innerHTML = '';
        this.personalize.previewBox?.querySelector('.personalize-preview-box')?.appendChild(fragment);
        this.personalize.previewBox.style.display = 'block'; 
        console.log('length: ', this.canvas.attributeIds.length < 2)
        if(this.canvas.attributeIds.length < 2) {
          this.personalize.previewBox.querySelector('.personalize-canvas-prev').style.display = 'none';
          this.personalize.previewBox.querySelector('.personalize-canvas-next').style.display = 'none';
        }
        else {
          this.personalize.previewBox.querySelector('.personalize-canvas-prev').style.display = 'block';
          this.personalize.previewBox.querySelector('.personalize-canvas-next').style.display = 'block';
        }
        // this.personalize.previewBox.style.display = 'block';
        // const previewNode = this.canvas.cloneNode(true);
        // this.personalize.previewBox?.querySelector('.personalize-preview-box')?.innerHTML = '';
        // this.personalize.previewBox?.querySelector('.personalize-preview-box')?.appendChild(previewNode); 
        // const wrapper = this.canvas.closest('.product__media-list');
        // wrapper.scrollLeft = 0;
        // document.documentElement.scrollTop = 0;
        
      });
    }
    changeEventListener (elems) {
      const self = this;
      elems.forEach(function (item) {
        item.addEventListener('change', function (e) {
          const target = e.target;
          const box = target.closest('.personalizeBox_group');
          const groupId = parseInt(box.dataset.attributeId);
          const mergeFront = parseInt(box.dataset.mergeFront);
          const textContent = target.querySelector('option:checked').textContent.trim();
          const currentAttributeInfo = this.inputInfo.get(groupId).info;

          if (mergeFront) {
            // 合并字体选择后，将值赋给两个输入框的父级，并移除他们各自的css变量
            box.setAttribute('style', `--personalize-fontFamily: ${textContent}`);
            box.querySelectorAll('.personalizeBox').forEach(item => {
              item.removeAttribute('style');
            });
            currentAttributeInfo.forEach(item => {
              item.fontFamily = textContent;
            });
          } else {
            target.closest('.personalizeBox').parentElement.setAttribute('style', `--personalize-fontFamily: ${textContent}`);
            const inputInfo = currentAttributeInfo.find(item => target.closest('.personalizeBox').parentElement.querySelector('input.personalize_input, textarea.personalize_input').dataset.inputInfoId == item.id);

            inputInfo.fontFamily = textContent;
          }
          this.personalize.getVariantSetting(target, groupId, this.currentVariantSettings);
          this.renderCanvas(target);
        }.bind(self));
      });
    }
    renderCanvas (target) {
      const showType = this.showType;
      let canvasStep;
      if (showType) {
        canvasStep = target.closest('personalize-group-step');
        const attributeId = parseInt(canvasStep.dataset.attributeId);
        canvasStep.renderCanvas(attributeId);

      } else {
        console.log('target:', target);
        if(target) {
          const group = target.closest('.personalizeBox_group')
          const attributeId = parseInt(group.dataset.attributeId);
          canvasStep = this.canvas;
          console.log('attributeId:', attributeId);
          canvasStep.renderCanvas(attributeId);
        }
      }
    }
    restInputInfo () {
      // this.personalize.originInfo
      this.inputInfo.clear();
    }
  }
  window.customElements.define('personalize-canvas', PersonalizeCanvas);

}



if (!window.customElements.get('personalize-step')) {
  class PersonalizeStep extends HTMLElement {
    constructor() {
      super();
      this.isMobile = window.matchMedia('(max-width: 768px)').matches;
      this.canvas = '';
      this.attributeIds = [];
      this.controllerElement = new Map();
      const dataset = this.dataset;
      this.attributeId = '';
      // 当前inputInfo所属的组id（attributeId）
      
      // 画布内容
      this.previewFile = new Map();
      this.contorllerInputInfo = '';
      this.parent = '';
      const showType = parseInt(dataset.showType);
      this.showType = showType;
      this.debounceToDataURL = debounce((event) => {
        this.toPersonalizedImg();
      }, 500);
      this.snowBg = '';
    }
    connectedCallback () {
      const coolDreamCanvas = this.querySelector('canvas');
      const parentElement = coolDreamCanvas.closest('ul, .personalize-content');
      // const width = this.isMobile ? Math.min(parentElement.clientWidth, parentElement.clientHeight) : parentElement.clientWidth;
      const size = this.isMobile ? document.body.clientWidth : parentElement.clientWidth;
      const options = {
        width: size,
        height: size,
        crossOrigin:'anonymous',
        // backgroundColor: "#fff", 
        backgroundColor: 'white', // 设置背景色为白色
      };
      this.canvas = new fabric.Canvas(coolDreamCanvas, options); 
      this.snowBg = this.querySelector('.personlizer-snow-img')?.src;
      const prevButton = this.querySelector('.personlizer-canvas-prev');
      const nextButton = this.querySelector('.personlizer-canvas-next');
      const closeButton = this.querySelector('.personlizer-canvas-close');
      if(closeButton) {
        closeButton.addEventListener('click', () => {
          this.hide();
        })
      }
      if(this.attributeIds.length < 2) {
        nextButton.style.display = 'none';
        prevButton.style.display = 'none';
      }
      if(nextButton) {
        nextButton.addEventListener('click', () => {
          let idx = this.attributeIds.indexOf(this.attributeId);
          if(idx + 1 < this.attributeIds.length) {
            idx += 1;
          }
          else {
            idx = 0;
          }
          this.renderCanvas(this.attributeIds[idx]);
        })
      }
      if(prevButton) {
        prevButton.addEventListener('click', () => {
          let idx = this.attributeIds.indexOf(this.attributeId);
          if(idx - 1 >= 0) {
            idx -= 1;
          }
          else {
            idx = this.attributeIds.length - 1;
          }
          this.renderCanvas(this.attributeIds[idx]);
        })
      }
    }

    async renderCanvas (attributeId) {
      if (this.showType == 0) {
        const id = this.dataset.personlizerId;
        console.log('id:', id);
        this.parent = document.getElementById(id);
        this.personalizeForm = this.parent.personalize;
      }
      this.attributeId = attributeId;
      const canvas = this.canvas;
      canvas?.clear();
      const width = canvas.width;
      const height = canvas.height;
      const attributeIdNum = parseInt(attributeId);
      this.groupId = attributeIdNum;
      if(!this.parent.inputInfo.get(attributeIdNum)) {
        console.log('attributeIdNum:', attributeIdNum);
        return false;
      }
      this.inputInfo = this.parent.inputInfo.get(attributeIdNum).info;

      const custom_bg_img = this.personalizeForm.bgObj[attributeIdNum];

      const bgInstance = new fabric.Image(custom_bg_img,
        {
          selectable: false,
          crossOrigin: 'anonymous'
        }
      );

      const originalWidth = bgInstance.width;
      const originalHeight = bgInstance.height;
      const scaleRatioWidth = width / originalWidth;
      const scaleRatioHeight = height / originalHeight;
      const scaleRatio = Math.max(scaleRatioWidth, scaleRatioHeight);

      bgInstance.scaleToWidth(originalWidth * scaleRatio);
      bgInstance.scaleToHeight(originalHeight * scaleRatio);

      bgInstance.moveTo(1);
      canvas.add(bgInstance);
      bgInstance.sendToBack();
      window.dispatchEvent(new Event('personalizeChange'));
      
      const inputInfos = [];
      let textColor = '';
      this.inputInfo.forEach(v => {
        if(v.group_name === 'T Shirt Text Color' || v.group_name === 'Text Color for Blanket' || v.group_name === 'Text Color for Throw Pillow') {
          const textColorMap = {
            Black:'#000000',
            White:'#ffffff',
            Gray:'#dfe0e2',
            'Dark Gray':'#7b7f82',
            'Cobalt Blue':'#163f9b',
            Navy:'#0c2аба',
            Red:'#d83b34',
            Pink:'#f57cc1',
            Purple:'#9a67f2',
            Green:'#30a324',
            'Light Blue':'#51d1ff',
            Yellow:'#fec70b',
            Orange:'#ff9c2c',
            Turquoise:'#07a1d7',
          }
          textColor = textColorMap[v.label]
        }
        else if(v.group_name === 'Text Color for Cap' || v.group_name === 'Text Color for Stocking') {
          const textColorMap = {
            Orange:'#ec8534',
            Green:'#32a37c',
           'Dark Blue':'#1d206c',
            White:'#ffffff',
            'Fluorescent Pink':'#f26a7f',
            'Dark Red':'#77292d',
            'Light Pink':'#f3dcdf',
            Silver:'#989999',
            Red:'#c42023',
            Gold:'#eee6b5',
            Black:'#000000',
            Purple:'#4e16a0',
          }
          textColor = textColorMap[v.label]
        }
        else if(v.group_name === 'Text Color for Ornament') {
          const textColorMap = {
            Green:'#009944',
            White:'#ffffff',
            Red:'#e60012',
            Black:'#231815',
          }
          textColor = textColorMap[v.label]
        }
        else if(v.input_type === 1 && v.group_name.indexOf('Snowflake') > -1 && v.value) {
          // 特定上传图加雪花图层
          inputInfos.push(v);
          inputInfos.push({
            ...v,
            group_name: 'Snow Bg',
            value: this.snowBg,
            image_layer: 0
          })
        }
        else {
          inputInfos.push(v); 
        }
      });
      const element = inputInfos.map(async function (inputInfo, index) {
        const { width_percent, height_percent, x_position_percent, y_position_percent, font_size, value = '', fontFamily, color, input_type, line_count, image_layer, shape, scaleX = 1, scaleY = 1, font_curved = 0 } = inputInfo;
        let boxX = width * x_position_percent,
          boxY = height * y_position_percent,
          boxWidth = width * width_percent,
          boxHeight = height * height_percent;
        console.log('input_type %s, boxwidth %s, boxheight %s,boxx %s,boxy %s,', input_type, boxWidth, boxHeight, boxX, boxY);

        // const circle = new fabric.Circle({
        //   left: 0,
        //   top: 0,
        //   // width: '5px',
        //   radius: 5,
        //   fill: '#000'
        // })
        let element;
        const targetWidth = boxWidth;
        const targetHeight = boxHeight;
        console.log('switchFabricObject 0', inputInfo);
        // 图片
        if (input_type == 1 || input_type == 2) {
          // const rect = new fabric.Rect({
          //   left: boxX,
          //   top: boxY,
          //   width: boxWidth,
          //   height: boxHeight,
          //   fill: 'transparent',
          //   // absolutePositioned: true,
          //   hasControls: false,
          //   selectable: false,
          //   strokeWidth: 2,  // 设置边框宽度
          //   stroke: '#2196f3',   // 设置边框颜色
          // })
          // canvas.add(rect);
          element = await this.switchFabricObject(inputInfo, boxWidth, boxHeight, boxX, boxY, width/400);


          // 计算调整比例
          const scaleRatioWidth = targetWidth / element.width;
          const scaleRatioHeight = targetHeight / element.height;
          console.log('scaleRatioHeight Math.max', Math.max(targetWidth, targetHeight));
          // 设置裁剪图像的大小
          element.scaleToWidth(input_type == 2 ? Math.max(targetWidth, targetHeight) : targetWidth, true);
          // element.scaleToHeight(targetHeight, true);
          element.set({ angle: inputInfo.angle });

          console.log('element.getScaledWidth', element.getScaledWidth());
          if (shape === 2) {
            element.clipPath = new fabric.Circle({
              radius: Math.max(targetWidth, targetHeight) / 2,
              fill: 'transparentCorners',
              absolutePositioned: true,
              hasControls: false,
              selectable: false,
              left: boxX,
              top: boxY,

            });
          } else {
            element.clipPath = new fabric.Rect({
              width: boxWidth,
              height: boxHeight,
              fill: 'transparentCorners',
              absolutePositioned: true,
              hasControls: false,
              selectable: false,
              // originX: 'center', originY: 'center',
              left: boxX,
              top: boxY,
              angle: inputInfo.angle,
            });

          }

        } else {
          // const rect = new fabric.Rect({
          //   left: boxX,
          //   top: boxY,
          //   width: boxWidth,
          //   height: boxHeight,
          //   fill: 'transparent',
          //   // absolutePositioned: true,
          //   hasControls: false,
          //   selectable: false,
          //   strokeWidth: 2,  // 设置边框宽度
          //   stroke: '#2196f3',   // 设置边框颜色
          // })
          // canvas.add(rect);
          element = this.switchFabricObject(inputInfo, boxWidth, boxHeight, boxX, boxY, width/400, textColor, font_curved); 
          console.log('element', element.width, element.height, targetWidth, targetHeight, inputInfo.fontFamily);
          // 计算调整比例
          // if (element.width > boxWidth) {
          //   const scaleRatioWidth = targetWidth /element.width;
          //   element.scaleToWidth(element.width * scaleRatioWidth, true);
          //   console.log('element scaleRatioWidth', scaleRatioWidth);

          // }
          // if (element.height > boxHeight) {
          //   const scaleRatioHeight = targetHeight / element.height;

          //   element.scaleToHeight(element.height * scaleRatioHeight, true);
          //   console.log('element scaleRatioHeight', scaleRatioHeight);

          // }
        }
        if (input_type == 1 || input_type == 2) {
          // 0文件在顶层，1文件在图层底部
          // image_layer ? element.sendToBack() : element.bringToFront();
          element.input_type = input_type;
          element.image_layer = image_layer;
          // console.log('elememt', inputInfo.group_name, inputInfo.image_layer, element)

        }
        return element;
        // canvas.add(circle);

      }.bind(this));
      console.log('element:', element);
      return Promise.all(element)
      .then(results => {
        results.forEach(item => {
          console.log('item:', item);
          canvas.add(item);
          if (item.input_type == 1 || item.input_type == 2) {
            item.image_layer ? item.sendToBack() : item.bringToFront();
            // item.bringToFront();
          }
          if (this.localName == 'personalize-step') {
            this.show();
          }
        });
        console.log('results:', results);
      })
      .then(() => {
        this.debounceToDataURL.apply(this);
        return canvas;
      });

      // const btn = document.getElementById('cd-btn');
      // const input = document.getElementById('input-test');
      // const textarea = document.getElementById('textarea');
      // btn.addEventListener('click', function () {
      //   console.log(canvas.getObjects())
      // });
    }
    toPersonalizedImg () {
      const canvas = this.canvas;
      console.log('canvas:', canvas);
      // 获取画布数据的 URL（PNG 格式）
      var canvasDataURL = canvas.toDataURL({ format: 'jpeg', multiplier: 1.5, quality: 1 }); 
      // const group_name = this.contorllerInputInfo.group_name;
      // const formId = this.controllerElement.closest('.product-form__input').querySelector('.personalize_input').getAttribute('form');
      // 获取personalize-form，查看inputInfo的size，如果大于1，则以数组返回。
      // const size = this.personalizeForm.inputInfo.size;


      // 将数据 URL 转换为 Blob 对象
      return fetch(canvasDataURL)
        .then(response => response.blob())
        .then(blob => {
          // 创建 File 对象
          var file = new File([blob], 'canvasImage.jpeg', { type: 'image/jpeg' });

          // 创建 FormData 对象
          console.log('toPersonalizedImg', file);
          if (this.groupId) {
            this.previewFile.set(this.groupId, file);
          }
          console.log('this.previewFile', this.previewFile);
          // // 将文件追加到 FormData 对象中
          // var formData = new FormData();
          // formData.append(`properties[preview_${group_name}]`, file);

          // // 将 FormData 对象附加到表单中
          // var form = document.getElementById(formId);
          // form.appendChild(formData);

          // 提交表单
          // form.submit();
        });
      /* // 将Canvas内容转为数据URL
      const dataURL = this.canvas.toDataURL('image/jpeg');

      // 解码数据URL为二进制数据
      const byteString = atob(dataURL.split(',')[1]);
      const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      // 创建Blob对象
      const blob = new Blob([ab], { type: mimeString });

      // 创建File对象
      const file = new File([blob], 'image.jpg', { type: mimeString });
      return file; */
    }



    switchFabricObject (inputInfo, width, height, boxX, boxY, scaleRatio, textColor, fontCurved) {
      const { width_percent, height_percent, x_position_percent, y_position_percent, font_size, value = '', fontFamily, color, word_count, input_type, line_count, id, angle } = inputInfo;
      if (input_type) {
        return new Promise((resolve, reject) => {

          fabric.Image.fromURL(value, function (img) {
            img.set({
              id: `contorllerClipPath${id}`,
              // originX: 'left', originY: 'top',
              left: boxX,
              top: boxY,
              hasControls: false,
              selectable: false,
              crossOrigin: 'anonymous'
            });
            resolve(img);
            // canvas.add(img);
          }, { crossOrigin: 'anonymous' });
        });

      } else {
        /*
        当originY设置为"top"时，文本框的顶部与设置的top位置对齐。
        当originY设置为"center"时，文本框的中心与设置的top + height/2位置对齐。
        当originY设置为"bottom"时，文本框的底部与设置的top + height位置对齐。
         */
        /*
          line_count == 1 ? new fabric.Text(value, {
          // width: width,
          // height: height,
          // originX: 'left', originY: 'bottom',
          left: -width / 2,
          top: -font_size / 2 + 5,
          fontSize: font_size,
          // fontFamily: 'sans-serif',
          // fill: color,
          hasControls: false,
          selectable: false

        }) :
        */
        console.log('fontFamily', width, height, fontFamily);
        return new fabric.Textbox(value, {
          // width: (word_count / line_count) * (font_size / 2),
          // charSpacing: font_size / 4,
          width: width,
          height: height,
          splitByGrapheme: true,
          left: boxX,
          top: boxY,
          textAlign: 'center',
          // originX: 'left', originY: 'bottom',
          // left: -width / 2,
          // top: -font_size / 2 + 5,
          // fontSize: Math.max(font_size * (300 / 400), 12),
          fontSize: Math.max(font_size * scaleRatio , 12),
          lineHeight: 1,
          fontFamily: fontFamily || 'sans-serif',
          fill: textColor || color,
          hasControls: false,
          selectable: false,
          angle,
          path: fontCurved ? (() => {
            const startX = 0;
            const startY = 0;
            const cx1 = startX + width/3;
            const cy1 = startY - height * fontCurved / 10;
            const cx2 = startX + width*2/3;
            const cy2 = startY - height * fontCurved / 10;
            const endX = startX + width;
            const endY = startY;

            const d = `M ${startX},${startY} C ${cx1},${cy1} ${cx2},${cy2} ${endX},${endY}`;
            return new fabric.Path(d, { fill: '', stroke: '', selectable: false, evented: false });
          })() : undefined
        });
      }
    }

    show () {
      // const btn = this.querySelector('.personalize-close-btn');
      if (this.isMobile) {
        // const wrapper = this.closest('.product__media-wrapper');
        // wrapper.classList.add('personalize-mobile', 'sticky');

        // !btn && this.closeBtn();
      }
      else {
        const parentElement = this.closest('.personalize-canvas');
        if (!parentElement.classList.contains('show')) {
          parentElement.classList.add('show', 'is-active');
        }
      }
    }
    hide () {
      
      if (this.isMobile) {
        // const wrapper = this.closest('.product__media-wrapper');
        // wrapper.classList.remove('personalize-mobile', 'sticky');
      }
      else {
        const parentElement = this.closest('.personalize-canvas');
        parentElement.classList.remove('show', 'is-active');
      }
    }
    closeBtn () {
      const btn = document.createElement('button');
      btn.setAttribute('type', 'button');
      btn.classList.add('personalize-close-btn');
      this.prepend(btn);
      btn.addEventListener('click', () => {
        this.hide();
      });
    }

    canvasClear () {
      this.canvas.clear();
    }

    exportAllImages() {
      console.log(this.attributeIds);
      
    }
  }

  window.customElements.define('personalize-step', PersonalizeStep);

  class PersonalizeGroupStep extends PersonalizeStep {
    constructor() {
      super();
      this.createCanvas();
      this.parent = this.closest('personalize-canvas');
      this.personalizeForm = this.parent.personalize;
      const dataset = this.dataset;
      const attributeId = parseInt(dataset.attributeId);
      this.inputInfo = this.parent.inputInfo.get(attributeId).info;

      this.custom_bg_img = this.personalizeForm.bgObj[attributeId];

    }
    static get observedAttributes () {
      return ['class']; // 添加你想监听的属性
    }

    createCanvas () {
      const sectionElem = document.createElement('section');
      sectionElem.classList.add('personalizeBox-canvas-box');
      const canvas = document.createElement('canvas');
      canvas.classList.add('coolDreamCanvas');
      canvas.setAttribute('width', 300);
      canvas.setAttribute('height', 300);
      canvas.setAttribute('id', 'coolDreamCanvas-step');
      sectionElem.appendChild(canvas);
      this.prepend(sectionElem);
      this.attributeId = parseInt(this.dataset.attributeId);

    }
    connectedCallback () {
      const options = {
        width: 300,
        height: 300,
        // backgroundColor: "#fff",
        backgroundColor: 'white', // 设置背景色为白色
        selectable: false,
        selection: false,
        isDrawingMode: false,
        allowTouchScrolling: true,
        crossOrigin: 'anonymous'
      };
      const coolDreamCanvas = this.querySelector('.coolDreamCanvas');
      this.canvas = new fabric.Canvas(coolDreamCanvas, options);
      this.renderCanvas(this.attributeId);

    }
    attributeChangedCallback (name, oldValue, newValue) {
      if (name === 'class' && newValue.includes('active') && this.canvas) {
        console.log(`属性 ${name} 已由 ${oldValue} 变更为 ${newValue}。`);


        this.renderCanvas(this.attributeId);
      }
    }
  }
  window.customElements.define('personalize-group-step', PersonalizeGroupStep);
}

function imageSort (images) {
  return images.sort((current, next) => {
    const cSort = parseInt(current.sort),
      nSort = parseInt(next.sort);
    const isNull = isNaN(cSort);
    return isNull ? -1 : cSort > nSort ? 1 : -1;
  });
}

// 同步执行三个函数，并按传入的顺序返回结果
async function executeFunctionsInOrder (functions) {
  const results = [];
  for (const func of functions) {
    const result = await func();
    results.push(result);
  }
  return results;
}

function calculateRepeatedSubtraction (initialValue, isAdd = false, n = 3) {
  let result = initialValue;

  for (let i = 0; i < n; i++) {
    result = isAdd ? result + result * (1 / 3) : result - result * (1 / 3);  // 每次减去当前值的三分之一
  }

  return result;
}

